import React from "react";
import { connect } from "react-redux";
import firebase from "firebase/app";
import "firebase/database";
import { setUserValue } from "../../redux/action/userAction";

class MeetupBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate = async (prevProps) => {
    if (this.props.weekId !== prevProps.weekId) {
      const weekRef = await firebase
        .database()
        .ref("weekly-topics")
        .child(this.props.weekId)
        .once("value");

      const meta = weekRef.val().meta;
      this.setState({ weekMeta: meta });
    }
  };

  onShowAuthModal = () => {
    this.props.setUserValue({ showSignInModal: true });
  };

  onShowAddNewProductModal = () => {
    this.props.setUserValue({ showAddNewProductModal: true });
  };

  render() {
    const { currentUser } = this.props.user;

    return (
      <section className="jumbotron text-center cta">
        <div className="introsection-div">
          <div className="container py-5">
            <h1 className="home-banner-title">Meetups for Indie Makers</h1>

            <p className="lead text-muted">
              Join our virtual meetups to make new friends, and help each other
              to make better products 🤗
            </p>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state && state.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setUserValue: (state) => {
    return dispatch(setUserValue(state));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MeetupBanner);
